(() => {
  const bindDrawerContent = (root, trigger) => {
    const drawer = trigger.closest('header-drawer');
    if (!drawer || !root) return;

    root.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('click', drawer.onSummaryClick.bind(drawer));
    });

    root.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => {
      button.addEventListener('click', drawer.onCloseButtonClick.bind(drawer));
    });
  };

  const hydrate = (trigger) => {
    const templateId = trigger && trigger.dataset.werollDeferredTemplate;
    if (!templateId) return null;

    const template = document.getElementById(templateId);
    if (!(template instanceof HTMLTemplateElement)) return null;

    const fragment = template.content.cloneNode(true);
    const roots = Array.from(fragment.children);
    const root = roots[0] || null;
    const isDrawer = template.hasAttribute('data-weroll-deferred-drawer');

    template.replaceWith(fragment);
    if (isDrawer) bindDrawerContent(root, trigger);

    document.dispatchEvent(new CustomEvent('weroll:deferred:hydrate', {
      detail: { root, roots, trigger },
    }));

    return root;
  };

  const hydrateFromEvent = (event) => {
    const trigger = event.target.closest('[data-weroll-deferred-template]');
    if (trigger) hydrate(trigger);
  };

  document.addEventListener('pointerover', hydrateFromEvent, true);
  document.addEventListener('pointerdown', hydrateFromEvent, true);
  document.addEventListener('focusin', hydrateFromEvent, true);
  document.addEventListener('click', hydrateFromEvent, true);
})();
